export const postalCodeRegExp = /^[A-Za-z0-9- ]+$/;
